"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisbursementFormula = void 0;
exports.getDisbursement = getDisbursement;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of Disbursement formala implementation names
 */
var DisbursementFormula;
(function (DisbursementFormula) {
    DisbursementFormula[DisbursementFormula["DEFAULT"] = 0] = "DEFAULT";
})(DisbursementFormula || (exports.DisbursementFormula = DisbursementFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getDisbursement(formula) {
    switch (formula) {
        default:
            return default_Disbursement;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_Disbursement = (drawAmount, drawFeeAmount) => {
    // ensure valid argument types
    if (typeof drawAmount === 'number' && typeof drawFeeAmount === 'number') {
        return (0, general_formulas_1.toFixedNumber)(drawAmount - drawFeeAmount, 2);
    }
    return NaN;
};
//# sourceMappingURL=disbursement-formula.js.map